
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class TermsOfServiceHeader extends Vue {}
